<template>
	<div class="icon__notice" ref="tooltip">
		<i class="fa-regular fa-bell icon"></i>
		<span class="count" v-if="countTotal > 0">{{ countTotal }}</span>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import Pusher from 'pusher-js';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // CSSのインポート
import { getCountTotalUnreadNotification } from '../modules/apiLaravel';
import { getCurrentYear } from '../modules/formatDate';

const countMypage = ref(0);
const countTournament = ref(0);
const volunteerId = ref(null);
const year = ref(getCurrentYear());
const tooltip = ref(null);

const pusherAppKey = ref(null);
const pusherCluster = ref(null);

let tooltipInstance = null; // Tippyインスタンスを格納する変数
let pusher = null;

const countTotal = computed(() => {
	return countMypage.value + countTournament.value;
});

const fetchCount = async () => {
	const response = await getCountTotalUnreadNotification(volunteerId.value, year.value);
	countMypage.value = response.count.mypage;
	countTournament.value = response.count.tournament;
};

// Tippyのインスタンスを作成し、ポップオーバーの内容を設定
const initializeTooltip = () => {
	tooltipInstance = tippy(tooltip.value, {
		content: generateTooltipContent(),
		allowHTML: true,
		trigger: 'mouseenter',
		interactive: true,
	});
};

const handlePusher = () => {
	const pusher = new Pusher(pusherAppKey.value, {
		cluster: pusherCluster.value,
		forceTLS: true,
	});

	pusher.connection.bind('error', (err) => {
		console.error('Pusher connection error:', err);
	});

	const channelMypage = pusher.subscribe('admin-notice-mypage');

	channelMypage.bind('AdminNotice', (event) => {
		if (year.value == event.year) {
			fetchCount();
		}
	});

	const channelTournament = pusher.subscribe('admin-notice-tournament');

	channelTournament.bind('AdminNoticeTournament', (event) => {
		fetchCount();
	});

	const channelStatusChange = pusher.subscribe('admin-status-change-event');

	channelStatusChange.bind('AdminStatusChange', (event) => {
		if (volunteerId.value == event.volunteer_id) {
			fetchCount();
		}
	});
};

// ポップオーバーの内容を生成する関数
const generateTooltipContent = () => {
	return `
		<p>会員お知らせ未読：${countMypage.value}</p>
		<p>大会お知らせ未読：${countTournament.value}</p>
	`;
};

// countMypageとcountTournamentが変化したときに内容を更新
watch([countMypage, countTournament], () => {
	if (tooltipInstance) {
		tooltipInstance.setContent(generateTooltipContent());
	}
});

onMounted(() => {
	const gnavNotice = document.getElementById('gnavNotice');
	volunteerId.value = gnavNotice.getAttribute('data-volunteer-id');
	pusherAppKey.value = gnavNotice.getAttribute('data-pusher-app-key');
	pusherCluster.value = gnavNotice.getAttribute('data-pusher-app-cluster');

	fetchCount();
	initializeTooltip();
	// handlePusher();
	setTimeout(() => {
		handlePusher(); // handlePusherを遅延して呼び出し
	}, 100);
});

onUnmounted(() => {
	if (pusher) {
		pusher.disconnect();
	}
});
</script>

<style lang="scss" scoped>
@use '../../sass/global/' as g;
.icon__notice {
	margin-left: 10px;
	position: relative;
	.icon {
		color: g.colors(theme, maroon);
		font-size: 2.2rem;
		cursor: pointer;
		@include g.responsive(sm) {
			font-size: 2.5rem;
		}
	}
	.count {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.8rem;
		width: 22px;
		height: 20px;
		padding: 2px;
		background-color: g.colors(theme, maroon);
		border: 1px solid g.colors(define, white);
		color: g.colors(define, white);
		border-radius: 50%;
		position: absolute;
		top: 1px;
		right: -6px;
	}
}
</style>
